import ProjectMessengerAvailability from "./ProjectMessengerAvailability";

export default function ProjectTeamAccess({
  gameId,
  value,
  onChange,
  hintExtra,
  readOnly = false,
}) {
  return (
    <div className="app-editor-settings__access-wrap">
      <section className="app-settings-card app-settings-card--access app-settings-card--access-compact">
        <h3 className="app-settings-card__title app-settings-card__title--left">
          Доступ для команды
        </h3>
        <div className="app-settings-access-body">
          <ProjectMessengerAvailability
            gameId={gameId}
            value={value}
            onChange={onChange}
            readOnly={readOnly}
            compact
            showShareLinks
            showShareGuide={false}
            hintExtra={hintExtra}
          />
        </div>
      </section>
    </div>
  );
}
